(() => {
  const installationKey = Symbol.for('mw-stkt.contact-transfer.installed');
  if (document[installationKey]) return;

  const calculatorKeys = ['room-size', 'room-height', 'window-size', 'persons', 'cooling-demand'];

  const contactTarget = (selector) => {
    try {
      return document.querySelector(selector || '#kontakt');
    } catch (_error) {
      return null;
    }
  };

  const setFormValue = (target, selector, value) => {
    const input = target.querySelector(selector);
    if (!input) return;
    input.value = value;
    input.disabled = false;
  };

  const updateDetailsField = (target) => {
    const details = [];
    const serviceInput = target.querySelector('[data-mw-stkt-contact-service="solution"]');

    if (serviceInput && !serviceInput.disabled && serviceInput.value) {
      details.push(`Gewählte Lösung: ${serviceInput.value}`);
    }

    const labels = {
      'room-size': 'Raumgrösse',
      'room-height': 'Raumhöhe',
      'window-size': 'Fensterfläche',
      persons: 'Personen',
      'cooling-demand': 'Kühlbedarf',
    };

    calculatorKeys.forEach((key) => {
      const input = target.querySelector(`[data-mw-stkt-contact-calculator="${key}"]`);
      if (input && !input.disabled && input.value) details.push(`${labels[key]}: ${input.value}`);
    });

    const detailsInput = target.querySelector('[data-mw-stkt-contact-details]');
    if (!detailsInput) return;

    detailsInput.value = details.join(' | ');
    detailsInput.disabled = details.length === 0;
  };

  const revealSelection = (target) => {
    const selection = target.querySelector('[data-mw-stkt-contact-selection]');
    if (selection) selection.hidden = false;
  };

  const scrollToContact = (target) => {
    target.scrollIntoView({
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      block: 'start',
    });
  };

  const handleServiceTransfer = (event) => {
    const target = contactTarget(event.detail?.target);
    const solution = event.detail?.solution?.trim();
    if (!target || !solution) return;

    setFormValue(target, '[data-mw-stkt-contact-service="solution"]', solution);

    const display = target.querySelector('[data-mw-stkt-contact-service-display]');
    if (display) display.textContent = solution;

    const panel = target.querySelector('[data-mw-stkt-contact-service-panel]');
    if (panel) panel.hidden = false;

    revealSelection(target);
    updateDetailsField(target);
    scrollToContact(target);
    event.preventDefault();
  };

  const handleCalculatorTransfer = (event) => {
    const target = contactTarget(event.detail?.target);
    const values = event.detail?.values;
    if (!target || !values) return;

    calculatorKeys.forEach((key) => {
      const value = values[key];
      if (!value) return;

      setFormValue(target, `[data-mw-stkt-contact-calculator="${key}"]`, value);
      const display = target.querySelector(`[data-mw-stkt-contact-calculator-display="${key}"]`);
      if (display) display.textContent = value;
    });

    const panel = target.querySelector('[data-mw-stkt-contact-calculator-panel]');
    if (panel) panel.hidden = false;

    revealSelection(target);
    updateDetailsField(target);
    scrollToContact(target);
    event.preventDefault();
  };

  const resetSelection = (target) => {
    target
      .querySelectorAll(
        '[data-mw-stkt-contact-calculator], [data-mw-stkt-contact-service], [data-mw-stkt-contact-details]'
      )
      .forEach((input) => {
        input.value = '';
        input.disabled = true;
      });

    target.querySelectorAll('[data-mw-stkt-contact-service-panel], [data-mw-stkt-contact-calculator-panel]').forEach((panel) => {
      panel.hidden = true;
    });

    const selection = target.querySelector('[data-mw-stkt-contact-selection]');
    if (selection) selection.hidden = true;
  };

  const handleResetClick = (event) => {
    const origin = event.target instanceof Element ? event.target : null;
    const button = origin?.closest('[data-mw-stkt-contact-reset]');
    if (!button) return;

    const target = button.closest('.mw-stkt-contact-footer');
    if (!target) return;

    resetSelection(target);
    const firstField = target.querySelector('.mw-stkt-contact__fields input');
    firstField?.focus({ preventScroll: true });
  };

  document.addEventListener('mw-stkt:service-transfer', handleServiceTransfer);
  document.addEventListener('mw-stkt:calculator-transfer', handleCalculatorTransfer);
  document.addEventListener('click', handleResetClick);
  document[installationKey] = true;
})();
